import Title from './title'
import Description from './description'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import AboutBlock from './block-about'

export default function StudioPerformance({ feedbacks }) {
  const t = useI18n()
  // const feedbacks = [1, 2, 3, 4, 5, 6, 7].map(() => ({
  //   avatar: 'https://cdn.style-map.com/user/head/small/210192_5.jpg',
  //   role: '店長',
  //   name: 'James qiu',
  //   studioName: 'Sinliya Hair Salon',
  //   feedback: '特約店有一套獨特的協作流程，你僅需要配合7天的駐店時間，整間店就可以運作的良好。特約店有一套獨特的協作流程（大約80字）。'
  // }))

  if (!feedbacks) return <> </>
  return (
    <div className=''>
      <AboutBlock>
        <Title>{ t('page:joinUs.feedback.title') }</Title>
        <div className='flex space-x-7 py-4 pl-2 pr-8 overflow-x-auto w-[85vw] md:w-full'>
          { feedbacks.map((feedback, index) => <Item key={ index } feedback={ feedback }/>)}
        </div>
      </AboutBlock>
    </div>
  )
}

const Item = ({ feedback }) =>
  <div className='rounded-xl shadow-[0_4px_12px_0px_rgba(0,0,0,0.1)]'>
    <div className='flex flex-col w-60 space-y-4 items-center text-lg p-6'>
      <div className='rounded-full border-2 border-[#EEEEEE]'>
        <C.Avatar src={ feedback.avatar } size='20'/>
      </div>
      <div className='font-bold'>{feedback.name}</div>
      <div className='text-sm text-gray-900 bg-gray-100 whitespace-pre-wrap px-3 py-1 leading-6'>{feedback.role}</div>
      <div className='text-gray-500 text-sm font-normal tracking-wider'>
        <span className='pr-1'><LocationOnIcon fontSize='small'/></span>
        {feedback.studioName}
      </div>
      <Description>{feedback.feedback}</Description>
    </div>
  </div>
